const EmptyHonoraireComp = () => (
  <li className="list-group-item">Pas de données correspondantes</li>
);

export default EmptyHonoraireComp;
